function MobileSection() {
  const { SectionEyebrow } = window.AppComponents;
  return (
    <section className="grid gap-7 rounded-[30px] bg-gradient-to-br from-slate-900 to-teal-900 p-7 text-white shadow-glow lg:grid-cols-[1fr_auto] lg:items-center">
      <div>
        <SectionEyebrow>Mobile-first service</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-white md:text-5xl">
          Track renewals, claims, and documents from your phone.
        </h2>
        <p className="mt-4 max-w-xl text-base leading-7 text-white/72">
          Follow policy reminders, monitor claim status, and keep every important
          document in a single dashboard built for quick mobile decisions.
        </p>
      </div>
      <div className="grid gap-5 lg:w-[320px]">
        <div className="overflow-hidden rounded-[28px] border border-white/10 bg-white/5 backdrop-blur-sm">
          <img
            src="https://images.unsplash.com/photo-1770368787756-c02439ce475f?auto=format&fit=crop&w=900&q=80"
            alt="Hand holding a smartphone with an app open"
            className="h-[320px] w-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <button className="rounded-full bg-gradient-to-br from-peach to-coral px-6 py-3.5 font-semibold text-white shadow-[0_14px_28px_rgba(225,95,56,0.26)] transition hover:-translate-y-0.5">
            Download App
          </button>
          <button className="rounded-full border border-white/20 bg-white/10 px-6 py-3.5 font-semibold text-white transition hover:-translate-y-0.5">
            Book Demo
          </button>
        </div>
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.MobileSection = MobileSection;
